export default __webpack_public_path__ + "static/media/door-to-door-disabled.5b9fcd7e.svg";